const constants = {
  /* FRONTEND VARIABLES */
  BorderRadius: {
    sm: `2px`,
    nm: `4px`,
    lg: `8px`,
    no: `0`,
    singleSm: `2px`,
    singleNm: `4px`,
    singleLg: `8px`,
    singleNo: `0`,
  },
  Breakpoints: { xs: 0, sm: 576, md: 768, lg: 992, xl: 1200, xxl: 1400 },
  Effect: {
    transitionBasic: `all 0.2s ease`,
    transitionImage: `all 0.6s ease`,
    boxShadowInput: `0 0 0 0.2rem rgb(213 96 143 / 25%)`,
  },
  Icon: {
    xt: 8,
    tn: 10,
    xs: 12,
    sm: 14,
    nm: 16,
    xn: 18,
    md: 20,
    xm: 22,
    lg: 24,
    xl: 32,
    hg: 40,
    xh: 48,
    xx: 64,
  },
  Layout: {
    containerXl: `90%`,
    gutterHalf: `15px`,
    gutter: `30px`,
    gutterDouble: `60px`,
  },
  MediaQueries: {
    phone: `only screen and (max-width:767px)`,
    tablet: `only screen and (min-width:768px) and (max-width:991px)`,
    gteTablet: `only screen and (min-width:768px)`,
    lteTablet: `only screen and (max-width:991px)`,
    desktop: `only screen and (min-width:992px) and (max-width:1199px)`,
    gteDesktop: `only screen and (min-width:992px)`,
    gteDesktopLg: `only screen and (min-width:1200px)`,
  },
  Modal: { sm: `340px`, nm: `500px`, lg: `800px`, xl: `1140px` },
  Size: {
    xt: `2px`,
    tn: `3px`,
    xs: `5px`,
    sm: `7px`,
    nm: `10px`,
    xn: `15px`,
    md: `20px`,
    xm: `25px`,
    lg: `30px`,
    xl: `40px`,
    hg: `50px`,
    xh: `60px`,
    xx: `80px`,
  },
  Theme: {
    _default: `#7B788F`,
    primary: `#5268e1`,
    primaryActive: `#2644D9`,
    secondary: `#0F0A32`,
    secondaryActive: `#140D40`,
    white: `#ffffff`,
    grey: `#a39c9b`,
    greyLight: `#d6cccb`,
    greyLighter: `#f0ebe8`,
    greyLightOpacity: `#f6f2f1`,
    transparent: `rgba(255,255,255,0)`,
    defaultActive: `#676978`,
    success: `#27c47a`,
    successActive: `#18B669`,
    successDark: `#0A3320`,
    warning: `#FAD957`,
    warningActive: `#E0C34F`,
    danger: `#FF8480`,
    dangerActive: `#E67773`,
    info: `#0071e3`,
    infoActive: `#0071e3`,
    facebook: `#4267B2`,
    google: `#EA4335`,
    payu: `#9dc53b`,
  },
  Type: {
    h1Size: `42px`,
    h2Size: `28px`,
    h3Size: `22px`,
    h4Size: `18px`,
    h5Size: `16px`,
    h6Size: `14px`,
    xt: `10px`,
    tn: `11px`,
    xs: `12px`,
    sm: `13px`,
    nm: `14px`,
    xn: `16px`,
    md: `18px`,
    xm: `22px`,
    lg: `28px`,
    xl: `36px`,
    hg: `42px`,
    xh: `56px`,
    xx: `64px`,
    light: `silkalight`,
    regular: `silkaregular`,
    medium: `silkamedium`,
    semibold: `silkasemibold`,
    bold: `silkabold`,
  },
  ZIndex: {
    bg: 0 - 1,
    base: 0,
    min: 1,
    first: 100,
    element: 500,
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
    preloader: 1100,
  },
  /* ENVIROMENT VARIABLES */
  Brand: {
    name: "Vivido",
  },
  CookiesOptions: {
    maxAge: 7 * 24 * 60 * 60,
    path: `/`,
  },
  Dates: {
    numeric: { year: "numeric", month: `numeric`, day: `numeric` },
  },
  Locale: { cs: `cs-CZ`, sk: `sk-SK`, en: `en-UK` },
  Locales: {
    cs: {
      lang: `cs`,
      language: `czech`,
      territory: `cz`,
      locale: `cs-CZ`,
      country: `Czech Republic`,
      currency: `CZK`,
    },
    sk: {
      lang: `sk`,
      language: `slovak`,
      territory: `sk`,
      locale: `cs-SK`,
      country: `Slovakia`,
      currency: `EUR`,
    },
    en: {
      lang: `en`,
      language: `english`,
      territory: `gb`,
      locale: `en-UK`, //TODO: correct iso en-GB
      country: `England`,
      currency: `EUR`,
    },
    _default: {
      lang: `cs`,
      language: `czech`,
      territory: `cz`,
      locale: `cs-CZ`,
      country: `Czech Republic`,
      currency: `CZK`,
    },
    _static: [{ lang: `cs` }, { lang: `sk` }, { lang: `en` }],
    // NEEDED FOR NEXT.JS. It needs to have "global" language, to be able to generate static pages without locale prefix.
  },
  Locations: {
    czechPlaceId:
      "Ei5SYWR1xYhza8OhIDE2MSwgNzQ3IDA2IE9wYXZhLVBvZHZpaG92LCBDemVjaGlhIjESLwoUChIJQcaSAMreE0cRv1ZbOTAn5uoQoQEqFAoSCSt2NtnJ3hNHETsFNlSj0Ymb",
  },
  LocalePriority: {
    czech: ["czech", "slovak", "english"],
    slovak: ["slovak", "czech", "english"],
    english: ["english", "czech", "slovak"],
    default: ["czech", "slovak", "english"],
  },
  Api: {
    MuxDataEnvKey:
      process.env.NODE_ENV === `development`
        ? "o19ajb6g2dk2ink1i5p4n0djk"
        : "4ivdiiqk83kjf822pgnqc4d43",
    UserComApiKey: "h3zgm5",
    fetchDefaultLimit: 10,
    fetchDefaultSort: "rating:desc",
  },
  Paths: {
    apiUrl:
      process.env.NODE_ENV === `development`
        ? process.env.NEXT_PUBLIC_BACKEND_URL
          ? process.env.NEXT_PUBLIC_BACKEND_URL
          : `http://localhost:1337`
        : `https://api.anandita.cz`,
    appUrl:
      process.env.NODE_ENV === `development`
        ? `http://localhost:3333`
        : process.env.VERCEL_URL
        ? `https://` + process.env.VERCEL_URL
        : `https://vivido.fit`,
    giftCard: "/class/darkovy-poukaz",
    calendar: "/cs/merch/kalendar-2023",
    imagesUrl: "",
    joinUs: "/join-us",
    accountPayments: "/account#payments",
    giftCardApplication: "/gift-card?code=",
    landingPageMembers: "/members",
    landingPageMembersCta: "/members#subscription",
    landingPageCompanies: "/companies",
    landingPageInstructors: "/instructors",
    pageBenefits: "/benefits",
    pageMerch: "/merch",
    pageClasses: "/classes",
    pageProfiles: "/profiles",
    pageContacts: "/contacts",
    pageCollections: "/collection/vip-program",
    muxImage: `https://image.mux.com/`,
    muxRtmp: "rtmp://global-live.mux.com:5222/app/",
    payuSecure: "https://corporate.payu.com/payment-security/",
    promoVideoCs: "https://youtu.be/HIGsbiXatJg",
    promoVideoSk: "https://youtu.be/HIGsbiXatJg",
    promoVideoEn: "https://youtu.be/Syzll5J9gpA",
    providerYoutube: `https://www.youtube.com/`,
    providerYoutubeChannel: `https://www.youtube.com/channel/`,
    providerVimeo: `https://www.vimeo.com/`,
    providerVimeoChannel: `https://www.vimeo.com/`,
    providerInstagram: `https://www.instagram.com/`,
    providerInstagramApi: `https://api.instacloud.io`,
    questionnaireYogis: `https://s.surveyplanet.com/5iCcVu0Lk`,
    questionnaireInstructors: `https://s.surveyplanet.com/cV3S8S3zQ`,
    defaultInstructorSlug: `barbora-hu`,
    defaultLectureSlug: `slunce-a-mesic`,
    defaultProgramSlug: `v-souladu`,
    publicTransferCS: `https://www.uschovna.cz/`,
    publicTransferSK: `http://www.sp-servis.sk/`,
    publicTransferEN: `https://www.wetransfer.com/`,
    profileEmailCS: `profil@vivido.fit`,
    profileEmailSK: `profil@vivido.fit`,
    profileEmailEN: `profile@vivido.fit`,
    profileDocumentCS: `https://www.anandita.life/docs/anandita_profil_manual.docx`,
    referralParam: `?utm_source=vivido&utm_medium=referral&utm_campaign=vivido`,
    registeredParam: `?registered=true`,
    cafeteriasBenefity: `https://benefity.cz/`,
    cafeteriasBenefitPlus: `https://www.benefit-plus.eu/`,
    cafeteriasSodexo: `https://mujpass.cz/cs/detail-provozovny/vivido-fit-online-lekce-jogy-pohybu-a-terapie?resultPosition=0&fulltext=vivido`,
    mediaCzecCrunch: `https://cc.cz/programator-zalozil-jogovou-platformu-a-nechal-ji-prorust-s-digitalem-ted-s-ni-jde-do-firem/`,
    mediaJogaDnes: `https://www.jogadnes.cz/joga/joga-dnes-listopad-prosinec-2022-vychazi-1-11-6044/`,
    mediaFlexityPodcast: `https://anchor.fm/flexity/episodes/Wellbeing-portl-Vivido-fit--Pavol-Hudran-16-e1ruj9t`,
    userComWidget: `https://vivido.user.com/widget.js`,
    docTariffEn: `https://anandita.fra1.digitaloceanspaces.com/docs/vivido_applicable_sales_tariffs_2023_en.pdf`,
    docTariffCs: `https://anandita.fra1.digitaloceanspaces.com/docs/vivido_platne_tarify_prodeje_2023_cz.pdf`,
    docTariffSk: `https://anandita.fra1.digitaloceanspaces.com/docs/vivido_platne_tarify_predaja_2023_sk.pdf`,
  },
  Intervals: {
    default: 10 * 60 * 1000,
    overlayDelay: { show: 100, hide: 100 },
  },
  Form: {
    mandatoryMessage: `Fill in this field, it is mandatory.`,
    errorMessage: `Uh-oh. Not all required informations are filled in!`,
    errorUnknownMessage: `Oops. The form could not be sent.`,
    successMessage: `Great! The form was sent successfully.`,
    phoneNote: `Enter the phone number, including the country code, eg +420 123 456 789`,
    emailNote: `The email format is name@domain.tld`,
  },
  /* CONTENT VARIABLES */
  Filter: {
    ShowRating: false,
    ShowDuration: false,
    SkillCategories: [`being`, `body`, `mind`, `soul`, `vitality`],
  },
  Images: {
    profilePhotoDesktop: 200,
    profilePhotoTablet: 180,
    profilePhotoPhone: 140,
    profilePhotoRowWidth: 200,
    profilePhotoBottomIntend: 20,
    profilePhotoLeftIntend: 30,
    profilePhotoListWidth: 160,
    profilePhotoFullSize: true,
    motivePhotoHeightDesktop: 400,
    motivePhotoHeightTablet: 320,
    motivePhotoHeightPhone: 240,
    motivePhotoFullSize: true,
    galleryPhotoHeightDesktop: 165,
    galleryPhotoHeightTablet: 185,
    galleryPhotoHeightPhone: 285,
    galleryPhotoMaxHeight: 640,
    galleryPhotoMaxWidth: 960,
    avatarWidthTetablet: 40,
    avatarWidthPhone: 32,
    videophotoFullSize: false,
    lottieDefaultOptions: {
      loop: true,
      autoplay: true,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    },
  },
  List: {
    hpAudios: [],
    hpClasses: [368, 349, 572, 315, 118, 117, 119, 285, 124, 186, 126, 155],
    /*
      368 – Dech radosti. Ideální proti depresi
      349 – Otevírání a uzamykání
      572 – Rozproudění energie a sebevědomí
      315 - Základní pohyby
      118 - Uvolnění a protažení krku
      117 - Funkční a pevný střed
      119 - Uvolnění hrudníku a ramen
      285 - Masáž celého těla I
      124 - Pozdrav slunci A a B
      186 - Hatha jóga - čtvrtá asánová praxe
      126 - Sedové pozice
      155 - Jógové osvěžení
      97 - Jógová praxe pro klidnou mysl
    */
    hpClassesRelax: [368, 349, 315, 118, 117, 119, 285, 124, 186, 126, 155, 97],
    hpClassesHealth: [
      368, 349, 315, 118, 117, 119, 285, 124, 186, 126, 155, 97,
    ],
    hpClassesGravid: [
      368, 349, 315, 118, 117, 119, 285, 124, 186, 126, 155, 97,
    ],
    hpClassesKids: [368, 349, 315, 118, 117, 119, 285, 124, 186, 126, 155, 97],
    hpFestivals: [22, 17, 22],
    /*
      22 - Prague spirit festival 2021
      17 - Festival jóga pro dobrou věc
     */
    hpInstructors: [33, 121, 151, 100, 1, 119, 7, 20, 6, 90, 78],
    /*
      33 - Alžběta Husáková
      121 – Tomáš Strnad
      151 - Jana Kyriaku
      100 – Jana Rachno
      1 - Barbora Hu
      119 - Kristýna Veit Tesařová
      7 - Dagmar Volfová
      20 – Renata Martinová
      6 - Katka Rojková
      90 - Markéta Leblová
      9 - Magdalena Štarhová
      78 - Veronika Carmanová
    */
    hpPartners: [],
    hpSeries: [20, 41, 52, 30, 44, 26, 5, 4, 6],
    /*
      20 - Masáže miminek pro správný psychomotorický vývoj
      41 - Lekce s Tomášem Strnadem
      52 - Teen jóga
      30 - Jóguj každý den
      44 - Pohyb bez bolesti
      26 – “Nadechni se” - kurz pranayamy
      5 - Minikurz jógy pro zdravá záda
      4 - Dobro pro tělo a mysl
      6 - 1. Série aštangové praxe
      */
    hpPlaylists: [1, 6, 4, 2, 5, 3],
    hpSeriesRelax: [26, 24, 5, 4, 20, 6, 16, 3, 13],
    hpSeriesHealth: [26, 24, 5, 4, 20, 6, 16, 3, 13],
    hpSeriesGravid: [26, 24, 5, 4, 20, 6, 16, 3, 13],
    hpSeriesKids: [26, 24, 5, 4, 20, 6, 16, 3, 13],
    hpStreams: [],
    limitAll: 1000,
    limitAnswers: 2,
    limitAvatars: 9,
    limitBenefitCardTags: 3,
    limitInstructors: 21,
    limitPartners: 100,
    limitVideos: 300,
  },
  Show: {
    accountSign: true, // login, register, user accoung
    accountBilling: false, // user account billing informations
    accountBecomeInstructor: false, // sign contract to become instructor from client
    accountCoupons: false, // user account coupons
    accountProfile: true, // user account profile
    accountPhotos: true, // user account photos
    accountContentForSale: true, // user account content for sale
    accountPayments: false, // user account payments
    accountContract: true, // user account contract details
    freeClassesInSeries: true, // free classes in series
    homepageContentAudio: false, // show audio in list of content
    homepageContentStream: false, // show stream in list of content
    homepagePlaylists: true, // show playlists on homepage
    homepagePlaylistsPersonal: false, // show personal advices on homepage
    homepageWhyToUseCompanies: true, // show stream in list of content
    instructorContacts: true, // contact to instructors in detail and on ohter places
    instructorGallery: true, // gallery in detail of instructor
    instructorInstagram: false, // instagram gallery in detaily of instructor
    instructorLoyalty: false, // loyalty level of instructor in detail
    instructorRates: true, // rates in detail of instructor
    contentAdd: false, // possibility to add new content (mostly video)
    contentAsanas: false, // asanas in list, detail and on other places
    contentDocuments: true, // attached documents in lecture or program detail
    contentMore: true, // more content in lists (mostly video)
    contentMux: true, // mux video on detail instead of yt
    contentQuestionnaire: true, // link to questionnaire in contact modal
    contentOfflineStorage: false, // possibility to download content to offline storage
    contentSamplesInModal: false, // open sample videos in modal
    navFavorite: false, // possibility to set content as favourite
    navFilter: true, // filtration menu in lists
    navLanguages: false, // show language switcher in header
    navPublishButtons: false, // publish buttons in detail of content
    navQuickplay: false, // quick filtration modal
    navRating: false, // possibility to rate any content and show results of ratings
    navSearch: true, // search in heading
    navSocialLogin: false, // login with Google or Facebook
    navSort: true, // sortin options in list header
    pageBenefits: true, // show link to store page
    pageNft: false, // show link to NFT Collection
    sale: true, // possibility to sell any content
    saleCartCoupons: true, // show coupons in cart
    salePaidContent: true, // info about paid content in every place
    streamCreate: true, // create new stream from profile account
  },
  Text: {
    descriptionRowsShort: 6,
    descriptionRowsMedium: 8,
    descriptionRowsLong: 12,
    descriptionCharsPerRow: 30,
  },
  Video: {
    // recommendedSeries: [`test-program-1`],
    // recommendedClasses: [`test-lekce-1`],
    recommendedSeries: [
      `cyklicka-joga-pro-vedomou-zenu`,
      `minikurz-jogy-pro-zdrava-zada`,
      `dobro-pro-telo-a-mysl`,
    ],
    recommendedClasses: [
      `kratka-joga-z-karibiku-garudasana`,
      `shakti-shiva-flow`,
      `pozdrav-slunce-se-zpivanim-manter`,
    ],
    streamFinishAfter: 5400, // after X seconds show Stream finished overlay
    sampleVideoCut: false, // custom youtube video cut after specific time
    sampleVideoLength: 15000, // sample youtube video length in miliseconds
  },
  VideoCard: {
    heightSm: `320px`,
    heightNm: `480px`,
    heightLg: `560px`,
    bodyHeightPreviewSm: `102px`,
    bodyHeightSeriesSm: `120px`,
    bodyHeightNm: `110px`,
    bodyHeightLg: `102px`,
  },
  Finance: {
    bankAccount: "2300192090/2010",
    payuId: process.env.NODE_ENV === `development` ? `421419` : `4122530`,
    priceCoeficient: 1,
    subscriptionPrices: [2, 1], // show two subcription on price page
    subscriptionTrialPrice: 1,
    subscriptionTrialPeriod: 7,
    subscriptionMonthPeriod: 30,
    subscriptionYearPeriod: 365,
  },
  Marketing: {
    gtmId: "GTM-5FZVZ4L",
    gaId: "UA-49971168-1",
    ogTitle: `Vivido - Your pause, your mental wellness; anywhere`,
    ogDescription: `Yoga classes, movement, therapy, all in one place`,
    mailchimpSubscribeUrl: `https://anandita.us15.list-manage.com/subscribe/post?u=8a1cf09603b04d4f7bcad90c5&amp;id=a7a5e6d972`,
    showPromoAlert: false, // alert at the top of page (500 Kč)
    subscriptionMembersBtnTitle: "Try 7 days for 1 Kč", // "Try 7 days for free" or "Try 7 days for 1 Kč"
    subscriptionCompaniesBtnTitle: "We want well-being at work", // "Try 7 days for free" or "Try 7 days for 1 Kč"
    subscriptionInstructorsBtnTitle: "I'm interested in that!", // "Try 7 days for free" or "Try 7 days for 1 Kč"
    giftCardId: 387,
  },
  Social: {
    fbPageId: `248522758665038`,
    fbAppId: `692729318532586`,
    fbPixelId: `371903434800149`,
    instagram: "https://www.instagram.com/vivido.fit/",
    facebook: "https://www.facebook.com/vividofit/",
    youtube: "https://www.youtube.com/channel/UC3mpRrTqBd0f3Eio2q6aAoQ",
    twitter: "https://twitter.com/vivido_fit",
    medium: "https://medium.com/@vivido-fit",
  },
  Marketplace: {
    opensea:
      "https://opensea.io/collection/vivido-fit-2023-yoga-movement-therapy",
  },
};

export default constants;
